<template>
  <Transition name="lvm-transition-y">
    <slot></slot>
  </Transition>
</template>

<style>
.lvm-transition-y-enter-active,
.lvm-transition-y-leave-active {
  transition: all 0.25s ease-out;
}

.lvm-transition-y-enter-from {
  transform: translateY(30px);
  opacity: 0;
}

.lvm-transition-y-leave-to {
  opacity: 0;
  transform: translateY(-30px);
}
</style>
